import React from "react";
import { Modal } from "react-bootstrap";
import Loadingcomponent from "../loader/loadingcomponent";
import { useTranslation } from "react-i18next";
import {useSelector} from "react-redux"

const SidebarModal = ({ show, toggleModal, logoutOk }) => {
  const { t } = useTranslation();
  const logintype = useSelector((state) => state?.userdata?.value?.loginmode);
  const msisdn = useSelector((state) => state?.userdata?.value?.selectedmsisdn);

  const closeModal = () => {
    toggleModal();
  };

  return (
    <Modal
      show={show}
      backdrop="true"
      className="bottom_modal animated  slideInUp faster sp16-modal-bounce-effect"
      onHide={closeModal}
    >
      <Modal.Body className="text-center">
        <div className="modal_img mb-4">
          <img
            src={process.env.PUBLIC_URL + "/assets/images/confirm_popup.svg"}
            width={60}
            alt=""
            title=""
          />
        </div>

        <p className="modal_p mb-4">{t("logoutmsg")}</p>
        <div className="flex_grp_align_center">
          <button
            type="button"
            className="custom_btn custom_btn_primary_outline btn_block me-2"
            onClick={() => {
              closeModal();
            }}
          >
            {t("cancel")}
          </button>
          <button
            type="button"
            className="custom_btn custom_btn_primary btn_block"
            onClick={logoutOk}
          >
            {t("ok")}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default SidebarModal;
